import React, { Fragment } from 'react';
import { Icon, Wrapper } from '@/components';
import { ModuleState, ValidatorStatus } from '@/sunzi';
import { validatorStyle, i18n } from '@/utils';
import styles from './style.less';

export interface OOPProps {
  visible: boolean;
  modules: ModuleState[];
  current: number;
  onClose: () => void;
}

const OOP: React.FC<OOPProps> = ({ visible, onClose, modules, current }) => {

  return visible ? (
    <Wrapper className={styles.oopWrapper}>
      <div className={styles.oop}>
        <div className={styles.oopContent}>
          <div className={styles.oopContentTitle}>
            <Icon type="block" color="#ff0136" />
            <span>{i18n.format('components.oop.title')}!</span>
          </div>
          <div className={styles.oopContentDescription}>{i18n.format('components.oop.description')}</div>
          <div className={styles.oopContentError}>
            {modules.slice(0, current + 1).map((item, index) => (
              <Fragment key={index}>
                <div className={styles.oopContentErrorItem}>
                  <span>{item.name}</span>
                  <div />
                  <Icon {...validatorStyle[item.validator.status]}></Icon>
                </div>
                {item.validator.status === ValidatorStatus.error && (
                  <div className={styles.oopContentErrorExtra}>
                    {item.validator.message.map((message, index) => (
                      <span key={index}>{message}</span>
                    ))}
                  </div>
                )}
              </Fragment>
            ))}
          </div>
          <div className={styles.oopContentButton} onClick={onClose}>{i18n.format('components.oop.submit')}</div>
        </div>
        <div className={styles.oopClose} onClick={onClose}>
          <Icon type="close" color="#fff"></Icon>
        </div>
      </div>
    </Wrapper>
  ) : null;
};

export default OOP;